import PropTypes from "prop-types";
import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { Redirect, useParams } from "react-router-dom";

import { Button, withStyles } from "@material-ui/core";

import API from "../../API";
import { withSnackbar } from "../../HOC/withSnackbar";
import { FilledTextField } from "../../components/FormElements";
import CenterWidget from "../../components/Layout/CenterWidget";
import WorkflowWrapper from "../../components/Layout/WorkflowWrapper";
import { loginStyles } from "./sharedStyles";

export const CreateNewPassword = (props) => {
  const { classes, t, setSnackbarMessage } = props;

  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [dirtyPassword, setDirtyPassword] = useState(false);
  const [dirtyConfirmation, setDirtyConfirmation] = useState(false);

  const handlePasswordChange = (e) => setPassword(e.target.value);
  const handleConfirmationChange = (e) => setConfirmation(e.target.value);

  const passwordsMatch = password === confirmation && password.length > 0;

  const validPW = password.length >= 8 && /[a-zA-Z]/.test(password);

  const handleSubmit = async () => {
    if (!validPW) {
      setSnackbarMessage("Invalid password");
    } else if (!passwordsMatch) {
      setSnackbarMessage(t("Errors.PasswordMatch"));
    } else {
      try {
        await API.auth.changePassword(password, token);
        setSnackbarMessage(t("User.PasswordChanged"));
        setShouldRedirect(true);
      } catch (e) {
        setSnackbarMessage(e.response.data || e.message);
      }
    }
  };

  return shouldRedirect ? (
    <Redirect to="/" />
  ) : (
    <WorkflowWrapper title="User.ChangePassword">
      <CenterWidget title="User.CreateNewPassword">
        <form>
          <FilledTextField
            value={password}
            onChange={handlePasswordChange}
            type="password"
            label={t("User.NewPassword")}
            error={dirtyPassword && !validPW}
            onBlur={() => setDirtyPassword(true)}
          />
          <FilledTextField
            value={confirmation}
            onChange={handleConfirmationChange}
            type="password"
            label={t("User.ReenterPassword")}
            error={dirtyConfirmation && !passwordsMatch}
            onBlur={() => setDirtyConfirmation(true)}
          />
          <Button
            className={classes.submit}
            variant="contained"
            color="secondary"
            onClick={handleSubmit}
          >
            {t("User.Send")}
          </Button>
        </form>
      </CenterWidget>
    </WorkflowWrapper>
  );
};

CreateNewPassword.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  setSnackbarMessage: PropTypes.func.isRequired,
};

export default withTranslation("common")(withStyles(loginStyles)(withSnackbar(CreateNewPassword)));
